
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/academy",
      function () {
        return require("private-next-pages/d/academy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/academy"])
      });
    }
  